import { createSelector } from "@reduxjs/toolkit";
import { formatLoans, formatPayment } from "components/loan/LoanTable/helpers";
import { formatPayments } from "components/payment/PaymentTable/helpers";
import { selectors } from "store";
import { getQueryFlags } from "./query";

export const getFormattedPayments = createSelector(
  selectors.payment.getEntitiesAsArray,
  selectors.job.getEntitiesAsArray,
  selectors.company.getEntitiesAsArray,
  (payments, jobs, companies) => formatPayments(payments, jobs, companies)
);

export const getFormattedPayment = createSelector(
  selectors.payment.getEntity,
  (payment) => formatPayment(payment)
);

export const getFormattedLoans = createSelector(
  selectors.credit.getEntitiesAsArray,
  selectors.job.getEntitiesAsArray,
  selectors.company.getEntitiesAsArray,
  getQueryFlags,
  (credits, jobs, companies, flags) =>
    formatLoans(credits, jobs, companies, flags.loans.solar)
);

export const getPaymentJob = createSelector(
  selectors.payment.getEntity,
  selectors.job.getEntities,
  (payment, jobs) => jobs[payment?.kid || ""]
);

export const getPaymentCredit = createSelector(
  selectors.payment.getId,
  selectors.credit.getEntities,
  (id, credits) => credits[id || ""]
);

const paymentSelectors = {
  ...selectors.payment,
  getFormattedPayments,
  getFormattedPayment,
  getFormattedLoans,
  getPaymentJob,
  getPaymentCredit,
};

export default paymentSelectors;
